(function () {
  function whenSwiperReady(callback) {
    if (typeof window.Swiper !== 'undefined') {
      callback();
      return;
    }
    var attempts = 0;
    var maxAttempts = 60;
    var id = window.setInterval(function () {
      attempts += 1;
      if (typeof window.Swiper !== 'undefined') {
        window.clearInterval(id);
        callback();
      } else if (attempts >= maxAttempts) {
        window.clearInterval(id);
      }
    }, 50);
  }

  function parseNum(value, fallback) {
    var n = parseFloat(String(value), 10);
    return Number.isFinite(n) ? n : fallback;
  }

  function isVideoInActiveSlide(video, root) {
    if (!video || !root || !root._shoppableSwiper) return false;
    var swiper = root._shoppableSwiper;
    var i = swiper.activeIndex;
    if (i < 0 || !swiper.slides || i >= swiper.slides.length) return false;
    var activeSlide = swiper.slides[i];
    return !!(activeSlide && activeSlide.contains(video));
  }

  /** If this video sits in the current Swiper slide, try muted autoplay (used after source changes / deferred retries). */
  function tryPlayVideoIfActiveSlide(video) {
    var root = video && video.closest ? video.closest('[data-shoppable-videos-root]') : null;
    if (!root || !isVideoInActiveSlide(video, root)) return;
    video.muted = true;
    video.play().catch(function () {});
  }

  function clearDeferredMp4Strip(videoEl) {
    if (!videoEl) return;
    if (videoEl._shoppableDeferStripTimer) {
      window.clearTimeout(videoEl._shoppableDeferStripTimer);
      videoEl._shoppableDeferStripTimer = null;
    }
    var sw = videoEl._shoppableDeferStripSwiper;
    var h = videoEl._shoppableDeferStripHandler;
    if (sw && h && typeof sw.off === 'function') {
      sw.off('slideChange', h);
      sw.off('slideChangeTransitionEnd', h);
    }
    delete videoEl._shoppableDeferStripSwiper;
    delete videoEl._shoppableDeferStripHandler;
  }

  /** On narrow viewports, keep only the lowest-bandwidth MP4 <source> when Shopify outputs several (faster start). Skips HLS-only setups. */
  function preferLowestMp4SourceOnMobile(video, signal) {
    if (!video || video.dataset.shoppableLowSourceDone === 'true') return;

    function markDone() {
      delete video.dataset.shoppableLowSwiperWait;
      video.dataset.shoppableLowSourceDone = 'true';
    }

    try {
      if (!window.matchMedia('(max-width: 749px)').matches) {
        markDone();
        return;
      }
      var sources = Array.prototype.slice.call(video.querySelectorAll('source[src]'));
      if (sources.length < 2) {
        markDone();
        return;
      }
      var hasHls = sources.some(function (s) {
        var t = (s.getAttribute('type') || '').toLowerCase();
        return t.indexOf('mpegurl') !== -1 || t.indexOf('m3u8') !== -1;
      });
      if (hasHls) {
        markDone();
        return;
      }

      var rootEarly = video.closest('[data-shoppable-videos-root]');
      var swiperEarly = rootEarly && rootEarly._shoppableSwiper;
      if (!swiperEarly && rootEarly) {
        var waitTries = parseInt(video.dataset.shoppableLowSwiperWait || '0', 10) || 0;
        if (waitTries < 40) {
          video.dataset.shoppableLowSwiperWait = String(waitTries + 1);
          window.setTimeout(function () {
            preferLowestMp4SourceOnMobile(video, signal);
          }, 80);
          return;
        }
      }

      function score(src) {
        var s = String(src);
        if (/2160|4k|uhd/i.test(s)) return 100;
        if (/1440|1440p/i.test(s)) return 90;
        if (/1080|1080p/i.test(s)) return 80;
        if (/720|720p/i.test(s)) return 60;
        if (/540|540p/i.test(s)) return 45;
        if (/480|480p/i.test(s)) return 40;
        if (/360|360p/i.test(s)) return 30;
        return 55;
      }

      sources.sort(function (a, b) {
        return score(a.src) - score(b.src);
      });
      var keep = sources[0];

      // video.load() after removing sources resets the element and cancels play() — worst on real phones
      // (≤749px path). If this clip is the Swiper active slide, defer strip until user leaves it (or timeout).
      function runStripAndReload() {
        if (video.dataset.shoppableLowSourceDone === 'true') return;
        clearDeferredMp4Strip(video);
        sources.forEach(function (s) {
          if (s !== keep) s.remove();
        });
        var replayedAfterReload = false;
        function replayIfStillActive() {
          if (replayedAfterReload) return;
          replayedAfterReload = true;
          tryPlayVideoIfActiveSlide(video);
        }
        if (signal) {
          video.addEventListener('canplay', replayIfStillActive, { once: true, signal: signal });
        }
        video.load();
        window.setTimeout(replayIfStillActive, 700);
        markDone();
      }

      var root = video.closest('[data-shoppable-videos-root]');
      var swiper = root && root._shoppableSwiper;
      var deferStrip = !!(swiper && typeof swiper.on === 'function' && isVideoInActiveSlide(video, root));

      if (deferStrip) {
        var onSlide = function () {
          if (isVideoInActiveSlide(video, root)) return;
          clearDeferredMp4Strip(video);
          runStripAndReload();
        };
        video._shoppableDeferStripHandler = onSlide;
        video._shoppableDeferStripSwiper = swiper;
        swiper.on('slideChange', onSlide);
        swiper.on('slideChangeTransitionEnd', onSlide);
        video._shoppableDeferStripTimer = window.setTimeout(function () {
          video._shoppableDeferStripTimer = null;
          if (video.dataset.shoppableLowSourceDone !== 'true') {
            clearDeferredMp4Strip(video);
            runStripAndReload();
          }
        }, 8000);
      } else {
        runStripAndReload();
      }
    } catch (e) {
      markDone();
    }
  }

  function syncNativeToggleUi(toggle, video, labelPlay, labelPause) {
    if (!toggle || !video) return;
    var paused = video.paused;
    toggle.classList.toggle('is-playing', !paused);
    toggle.setAttribute('aria-pressed', paused ? 'false' : 'true');
    toggle.setAttribute('aria-label', paused ? labelPlay : labelPause);
  }

  function initNativeWrap(wrap) {
    if (!wrap || wrap.dataset.shoppableNativeBound === 'true') return;
    wrap.dataset.shoppableNativeBound = 'true';

    var video = wrap.querySelector('video.shoppable-videos__video-el');
    var toggle = wrap.querySelector('[data-native-toggle]');
    var playCover = wrap.querySelector('[data-native-play-cover]');
    var labelPlay = wrap.getAttribute('data-label-play') || 'Play video';
    var labelPause = wrap.getAttribute('data-label-pause') || 'Pause video';

    if (!video) return;

    if (window.matchMedia('(max-width: 749px)').matches) {
      try {
        video.preload = 'metadata';
      } catch (e) {}
    }

    var ac = new AbortController();
    var signal = ac.signal;

    function syncPlayingUi() {
      if (video.paused) {
        wrap.classList.remove('shoppable-videos__native-root--video-playing');
      } else {
        wrap.classList.add('shoppable-videos__native-root--video-playing');
      }
      if (wrap.classList.contains('shoppable-videos__native-root--center-play-dismissed') && toggle) {
        wrap.classList.add('shoppable-videos__native-root--show-toggle');
      }
      if (playCover) {
        var centerDismissed = wrap.classList.contains('shoppable-videos__native-root--center-play-dismissed');
        var showCenter = !centerDismissed && video.paused;
        playCover.setAttribute('aria-hidden', showCenter ? 'false' : 'true');
      }
      if (toggle) syncNativeToggleUi(toggle, video, labelPlay, labelPause);
    }

    function onPlay() {
      wrap.classList.add('shoppable-videos__native-root--center-play-dismissed');
      if (toggle) wrap.classList.add('shoppable-videos__native-root--show-toggle');
      video.muted = true;
      syncPlayingUi();
    }

    function onPause() {
      syncPlayingUi();
    }

    video.addEventListener('play', onPlay, { signal: signal });
    video.addEventListener('pause', onPause, { signal: signal });
    video.addEventListener('ended', onPause, { signal: signal });
    video.addEventListener(
      'loadedmetadata',
      function onceMeta() {
        preferLowestMp4SourceOnMobile(video, signal);
      },
      { signal: signal, once: true }
    );

    if (playCover) {
      playCover.addEventListener(
        'click',
        function (e) {
          e.preventDefault();
          e.stopPropagation();
          video.muted = true;
          video.play().catch(function () {});
        },
        { signal: signal }
      );
    }

    if (toggle) {
      toggle.addEventListener(
        'click',
        function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (video.paused) {
            video.muted = true;
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        },
        { signal: signal }
      );
    }

    syncPlayingUi();

    wrap._shoppableNativeDestroy = function () {
      ac.abort();
      clearDeferredMp4Strip(video);
      if (toggle) wrap.classList.remove('shoppable-videos__native-root--show-toggle');
      wrap.classList.remove('shoppable-videos__native-root--video-playing');
      wrap.classList.remove('shoppable-videos__native-root--center-play-dismissed');
      delete video.dataset.shoppableLowSourceDone;
      delete video.dataset.shoppableLowSwiperWait;
      delete wrap.dataset.shoppableNativeBound;
      delete wrap._shoppableNativeDestroy;
    };
  }

  function initNativeIn(root) {
    if (!root) return;
    root.querySelectorAll('[data-shoppable-native]').forEach(initNativeWrap);
  }

  function destroyNativeIn(root) {
    if (!root) return;
    root.querySelectorAll('[data-shoppable-native]').forEach(function (wrap) {
      if (typeof wrap._shoppableNativeDestroy === 'function') {
        wrap._shoppableNativeDestroy();
      }
    });
  }

  function playActiveSlideMedia(root) {
    var swiper = root._shoppableSwiper;
    if (!swiper || !swiper.slides || !swiper.slides.length) return;
    var i = swiper.activeIndex;
    if (i < 0 || i >= swiper.slides.length) return;
    var slide = swiper.slides[i];
    if (!slide) return;

    var wrap = slide.querySelector('[data-shoppable-native]');
    var vid = wrap ? wrap.querySelector('video.shoppable-videos__video-el') : slide.querySelector('video.shoppable-videos__video-el');
    if (!vid || vid.tagName !== 'VIDEO') return;

    vid.muted = true;
    function attemptPlay() {
      if (!isVideoInActiveSlide(vid, root)) return;
      vid.muted = true;
      vid.play().catch(function () {});
    }
    attemptPlay();
    window.requestAnimationFrame(function () {
      if (!vid.paused) return;
      attemptPlay();
    });
    window.setTimeout(function () {
      if (!vid.paused) return;
      attemptPlay();
    }, 220);
    window.setTimeout(function () {
      if (!vid.paused) return;
      attemptPlay();
    }, 900);
  }

  function schedulePlayActiveSlideMedia(root) {
    if (!root) return;
    if (root._shoppablePlayDebounce) {
      window.clearTimeout(root._shoppablePlayDebounce);
    }
    root._shoppablePlayDebounce = window.setTimeout(function () {
      root._shoppablePlayDebounce = null;
      playActiveSlideMedia(root);
    }, 60);
  }

  function bindSectionMediaAutoplay(root) {
    if (root._shoppableSectionIo) {
      root._shoppableSectionIo.disconnect();
    }
    root._shoppableSectionIo = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) schedulePlayActiveSlideMedia(root);
        });
      },
      { root: null, threshold: 0.08, rootMargin: '0px 0px 12% 0px' }
    );
    root._shoppableSectionIo.observe(root);
  }

  function initRoot(root) {
    if (!root || root.dataset.shoppableSwiperInit === 'true') return;

    var el = root.querySelector('.shoppable-videos__swiper');
    if (!el) return;

    whenSwiperReady(function () {
      if (root.dataset.shoppableSwiperInit === 'true') return;

      var desktop = parseNum(root.dataset.slidesDesktop, 4);
      var tablet = parseNum(root.dataset.slidesTablet, 2.4);
      var mobile = parseNum(root.dataset.slidesMobile, 1.2);
      var space = parseNum(root.dataset.spaceBetween, 24);

      var paginationEl = root.querySelector('.shoppable-videos__pagination-wrap');
      var nextEl = root.querySelector('.shoppable-videos__button-next');
      var prevEl = root.querySelector('.shoppable-videos__button-prev');

      var swiper = new window.Swiper(el, {
        slidesPerView: mobile,
        spaceBetween: Math.round(Math.max(space * 0.65, 10)),
        watchOverflow: true,
        pagination: {
          el: paginationEl,
          type: 'progressbar',
        },
        navigation: {
          nextEl: nextEl,
          prevEl: prevEl,
        },
        breakpoints: {
          750: {
            slidesPerView: tablet,
            spaceBetween: Math.round(Math.max(space * 0.85, 14)),
          },
          990: {
            slidesPerView: desktop,
            spaceBetween: space,
          },
        },
        on: {
          init: function () {
            playActiveSlideMedia(root);
          },
          slideChangeTransitionEnd: function () {
            schedulePlayActiveSlideMedia(root);
          },
        },
      });

      root._shoppableSwiper = swiper;
      root.dataset.shoppableSwiperInit = 'true';

      bindSectionMediaAutoplay(root);
    });
  }

  function destroyRoot(root) {
    if (!root) return;
    if (root._shoppablePlayDebounce) {
      window.clearTimeout(root._shoppablePlayDebounce);
      root._shoppablePlayDebounce = null;
    }
    if (root._shoppableSectionIo) {
      root._shoppableSectionIo.disconnect();
      root._shoppableSectionIo = null;
    }
    destroyNativeIn(root);
    if (root._shoppableSwiper) {
      root._shoppableSwiper.destroy(true, true);
      root._shoppableSwiper = null;
    }
    delete root.dataset.shoppableSwiperInit;
  }

  function boot() {
    document.querySelectorAll('[data-shoppable-videos-root]').forEach(function (root) {
      initNativeIn(root);
      initRoot(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-shoppable-videos-root]');
    if (root) {
      initNativeIn(root);
      initRoot(root);
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('[data-shoppable-videos-root]');
    if (root) destroyRoot(root);
  });
})();
